import Accordion from "../../../../webpack/assets/scripts/extensions/accordion.js";

document.addEventListener("DOMContentLoaded", () => {
    new Accordion("#accordionInformationClause", {
        singleOpen: true,
        scrollToOpen: false
    });
});
